var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2NewHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M519,189c-0.1-0.9,0.1-1.9,0-2.5c-10-83.3-101.5-94.6-149.2-96C319.9,89,226.2,106,205.3,173.8h-0.1 c-0.2,0.8-0.4,1.7-0.6,2.5c-0.6,2.3-1.2,4.7-1.7,7.2c-9.1,41.6-9.1,95.1-1.7,130.3c4.7-36.7,12.8-135.3,60-132.7l-23.8-3.1 c5.1-4.4,10.3-8.8,16-12.2c46.4-28.4,103-30,155.3-21.8c25,3.9,50.5,12.5,73.1,23.8c4.9,2.4,9.1,6.5,12.9,11.1l-33.1,6.6 c11.7,6,22.6,20.1,25.5,23.5c18,20.5,26.5,87.5,24,132C516.7,317.9,525.8,224,519,189z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_8_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M524.1,195.8c4.2-4.3,20.6-18.3,13.7-22.6c-101.5-16.4-206.4-19.8-309.4-7.4c-13.6,1.6-27.1,3.5-40.6,5.6 c-7.7,1.4-15.3,2.9-22.8,4.5c-1.7,4.2,5,11.4,7.5,14.1c4.6,5.1,9.3,10.4,14.6,15c5.9,5.1,13.1,9.4,20.1,9.4 c93.7-20.3,193.3-19.4,288.9-3.5C508.5,210.3,516.5,203.6,524.1,195.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M216.9,167.2c-9.7,1.3-19.4,2.6-29.1,4.2c-7.7,1.4-15.3,2.9-22.8,4.5c-1.7,4.2,5,11.4,7.5,14.1 c4.6,5.1,9.3,10.4,14.6,15c5.9,5.1,13.1,9.4,20.1,9.4c34-7.4,68.8-11.9,103.9-14C276.7,195.6,241.5,187.5,216.9,167.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M223.5,79.3c-10.3,25.7-17.7,61.4-18.6,89.6c7.8-1.1,15.7-2.1,23.5-3.1c89.7-10.8,180.9-9.6,270,1.7 c-2.9-33-9-65.5-20.9-96.1C410.5,54.5,300.4,48.5,223.5,79.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M223.5,79.3c-8.3,20.7-14.7,48-17.4,72.5c12.1-2.4,24.6-4.4,37.3-6.1c0.1-25.3,4.6-54.8,11.1-76.4 C243.7,72,233.3,75.3,223.5,79.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M206.1,151.8c-0.6,5.9-1.1,11.6-1.2,17.1c7.8-1.1,15.7-2.1,23.5-3.1c89.7-10.8,180.9-9.6,270,1.7 c-0.5-5.2-1-10.4-1.6-15.6C408.5,133.6,297.9,133.9,206.1,151.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M446.2,143.7c-8.6-1-17.3-1.9-26.2-2.7l1,19.2c8.8,0.5,17.6,1.1,26.4,1.9L446.2,143.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2NewHair1);
export default __webpack_public_path__ + "static/media/m-hat2_new-hair1.ba13c1cf11addac4c38fc2d29a417e74.svg";
export { ForwardRef as ReactComponent };